<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Add Attachment</h4>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v.addAttachment" class="form-wrapper">
                <document-file-upload
                    :documents="documents"
                    :file-label="'files or images'"
                    :accepted-file-types="'.pdf,.jpg,.jpeg,.png'"
                    @upload-success="uploadDocumentSuccess"
                />
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">
                Cancel
            </md-button>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { required } from 'vuelidate/lib/validators';
import { DocumentFileUpload } from '@/components';

export default {
    name: 'BlockoutDayAttachmentModal',
    components: { DocumentFileUpload },
    mixins: [GeneralMixin],
    props: {
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            images: [],
            imageList: [],
            documents: [],
            documentList: []
        };
    },
    methods: {
        async addAttachment() {
            const photoFiles = this.imageList.map((item) => {
                return item.file.name;
            });

            const documentFiles = this.documentList.map((item) => {
                return item.file.name;
            });

            this.resolve({
                photoFileNames: photoFiles,
                documentFileNames: documentFiles,
                documentList: this.documentList,
                imageList: this.imageList
            });
        },
        async uploadDocumentSuccess(filelist) {
            const imageTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];

            // Document types
            const rawDocuments = filelist.filter((item) => !imageTypes.includes(item.type));
            const docs = rawDocuments.map((item) => {
                return { photoUrl: URL.createObjectURL(item), file: item, type: item.type };
            });

            // Images
            const rawImages = filelist.filter((item) => imageTypes.includes(item.type));
            const images = rawImages.map((item) => {
                return { photoUrl: URL.createObjectURL(item), file: item, type: item.type };
            });

            this.documents = rawDocuments;
            this.documentList = docs;

            this.images = rawImages;
            this.imageList = this.imageList.concat(images);

            await this.addAttachment();
        }
    },
    validations: {
        addAttachment: {
            note: {
                required
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.modal-container {
    max-width: 500px;
    .modal-body {
        min-height: 80px;
        padding: 15px 24px;
        .form-wrapper {
            position: relative;
            .label {
                margin: 10px 0;
                font-size: 14px;
                font-weight: bold;
            }
        }
    }
}
</style>
